import React, { useState } from 'react';
import styles from './ToxboxSection.module.css';

import WhatIsToxbox from './whatIsToxbox';
import VirtualReceptionist from './VirtualReceptionist/VirtualReceptionist';
import SupportedDevices from './SupportedDevices/SupportedDevices';
import InboundCallManagement from './InboundCallManagement/InboundCallManagement';
import AdminPanelGuide from './AdminPanelGuide/AdminPanelGuide';
import SubscriptionGuide from './SubscriptionGuide/SubscriptionGuide';

const ToxboxSection = () => {
  const [activeSection, setActiveSection] = useState('whatIsToxbox');

  const sections = {
    whatIsToxbox: <WhatIsToxbox />,
    virtualReceptionist: <VirtualReceptionist />,
    supportedDevices: <SupportedDevices />,
    inboundCallManagement: <InboundCallManagement />,
    adminPanelGuide: <AdminPanelGuide />,
    subscriptionGuide: <SubscriptionGuide />,
  };

  const articles = [
    { key: 'whatIsToxbox', title: "What is TOXBOX?" },
    { key: 'virtualReceptionist', title: "How to set up your virtual receptionist" },
    { key: 'supportedDevices', title: "Supported devices and browsers" },
    { key: 'inboundCallManagement', title: "How inbound calls are managed" },
    { key: 'adminPanelGuide', title: "Navigating the Admin Panel" },
    { key: 'subscriptionGuide', title: "Upgrade or cancel subscription" }
  ];

  return (
    <div className={styles.container}>
      {/* Left Content */}
      <div className={styles.left}>
        {sections[activeSection]}
      </div>

      {/* Right Sidebar */}
      <aside className={styles.sidebar}>
        <h3 className={styles.sidebarHeading}>Articles in this section</h3>
        <ul className={styles.articleList}>
          {articles.map(({ key, title }) => (
            <li key={key} className={styles.articleItem}>
              <button
                className={`${styles.link} ${activeSection === key ? styles.activeLink : ''}`}
                onClick={() => setActiveSection(key)}
              >
                {title}
              </button>
            </li>
          ))}
        </ul>
      </aside>
    </div>
  );
};

export default ToxboxSection;
